import type { WishlistMutationResponseDTO } from '../dto/wishlist.dto';
import type { WishlistState } from '../../domain/models/WishlistItem';

export function adaptWishlistMutationDtoToState(dto: WishlistMutationResponseDTO): WishlistState {
  return {
    itemCount: dto.wishListItemCount ?? 0,
    designIds: Array.isArray(dto.wishListItemDesignIds) ? dto.wishListItemDesignIds : [],
  };
}
